//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { PageUtils } from "./helpers/page-utils";
const _debounce = require('lodash.debounce');

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();
    setTimeout(() => { lightbox.dataset.hidden = 'true'; }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();
    document.getElementById('siteHeader').dataset.visible = 'false';
    document.body.dataset.navVisible = 'false';
    setTimeout(() => { lightbox.dataset.visible = 'true'; }, 50);
}

function updateNavButtons(swiper, prevEl, nextEl) {
    const prevButton = document.querySelector(prevEl);
    const nextButton = document.querySelector(nextEl);

    if (prevButton && nextButton) {
        prevButton.disabled = swiper.isBeginning;
        nextButton.disabled = swiper.isEnd;

        // Optionally, add/remove opacity styles for better UX
        prevButton.classList.toggle('opacity-50', swiper.isBeginning);
        prevButton.classList.toggle('pointer-events-none', swiper.isBeginning);

        nextButton.classList.toggle('opacity-50', swiper.isEnd);
        nextButton.classList.toggle('pointer-events-none', swiper.isEnd);
    }
}

function documentKeydownHandler(event, lightbox, swiper) {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === 'Escape') closeLightBox(lightbox);
        else if (event.key === 'ArrowRight') swiper.slideNext();
        else if (event.key === 'ArrowLeft') swiper.slidePrev();
    }
}

window.addEventListener('load', () => {
    const swiperElementsPresent = !!document.querySelector('.swiper');

    const cardPanel = document.querySelectorAll('.card-panel-slider');
    const featureEventsPanel = document.querySelectorAll('.feature-events-panel');
    const festivalHubsPanel = document.querySelectorAll('.festival-hubs-panel');
    const testimonialSliderPanel = document.querySelectorAll('.testimonial-panel-slider');
    const testimonialFaderPanel = document.querySelectorAll('.testimonial-panel-fader');
    const galleryPanel = document.querySelectorAll('.gallery-panel');
    const homeHeroPanel = document.querySelectorAll('.header-panel-home-hero');

    if (swiperElementsPresent) {

        // START FESTIVAL HUBS PANEL SLIDER
        for (const panel of festivalHubsPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="card-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                const cardSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: 3.1,
                            spaceBetween: 32,
                        },
                        1280: {
                            slidesPerView: 4,
                            spaceBetween: 32,
                        },
                    },
                });

                cardSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(cardSwiper, prevEl, nextEl);
                });
                updateNavButtons(cardSwiper, prevEl, nextEl);
            }
        }
        // END FESTIVAL HUBS PANEL SLIDER

        // START FEATURE EVENTS PANEL SLIDER
        for (const panel of featureEventsPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="card-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                const cardSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1280: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    },
                });

                cardSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(cardSwiper, prevEl, nextEl);
                });
                updateNavButtons(cardSwiper, prevEl, nextEl);
            }
        }
        // END FEATURE EVENTS PANEL SLIDER

        // START CARD PANEL SLIDER
        for (const panel of cardPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="card-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                const cardSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1280: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    },
                });

                cardSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(cardSwiper, prevEl, nextEl);
                });
                updateNavButtons(cardSwiper, prevEl, nextEl);
            }
        }
        // END CARD PANEL SLIDER

        // START STATS PANEL SLIDER
        // Swiper on mobile only, destroyed at md+ and rendered as a CSS grid
        const statsPanel = document.querySelectorAll('.stats-panel');
        const MD_BREAKPOINT = 768;

        for (const panel of statsPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="stats-slider"]');

            if (swiperElement) {
                const statsPerRow = parseInt(swiperElement.dataset.statsPerRow) || 4;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="stats-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="stats-slider-${swiperIndex}"]`;
                const navContainer = panel.querySelector(`[data-stats-nav="${swiperIndex}"]`);

                const gridColsClass = statsPerRow === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-3 xl:grid-cols-4';
                const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
                let statsSwiper = null;

                function createSwiper() {
                    if (statsSwiper) return;

                    // Remove grid classes from wrapper
                    if (swiperWrapper) {
                        swiperWrapper.classList.remove('grid', 'sm:grid-cols-2', 'lg:grid-cols-3', 'xl:grid-cols-4', 'gap-10', 'lg:gap-12');
                        swiperWrapper.style.display = '';
                    }
                    swiperElement.querySelectorAll('.swiper-slide').forEach(s => s.style.width = '');

                    statsSwiper = new Swiper(swiperElement, {
                        loop: false,
                        speed: 750,
                        direction: 'horizontal',
                        allowTouchMove: true,
                        slidesPerView: 1.2,
                        slidesPerGroup: 1,
                        spaceBetween: 24,
                        centeredSlides: false,
                        pagination: {
                            el: `[data-swiper-pagination="stats-slider-${swiperIndex}"]`,
                            clickable: true,
                            renderBullet: function (index, className) {
                                return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                            },
                        },
                        navigation: {
                            nextEl: nextEl,
                            prevEl: prevEl,
                        },
                        breakpoints: {
                            640: {
                                slidesPerView: 2.1,
                                spaceBetween: 24,
                            },
                        },
                    });

                    statsSwiper.on('reachBeginning reachEnd slideChange', function () {
                        updateNavButtons(statsSwiper, prevEl, nextEl);
                    });
                    updateNavButtons(statsSwiper, prevEl, nextEl);

                    if (navContainer) navContainer.style.display = '';
                }

                function applyGridLayout() {
                    if (swiperWrapper) {
                        swiperWrapper.style.display = 'grid';
                        swiperWrapper.classList.add('grid', 'sm:grid-cols-2', ...gridColsClass.split(' '), 'gap-10', 'lg:gap-12');
                    }
                    swiperElement.querySelectorAll('.swiper-slide').forEach(s => s.style.width = '');
                    if (navContainer) navContainer.style.display = 'none';
                }

                function destroySwiper() {
                    if (statsSwiper) {
                        statsSwiper.destroy(true, true);
                        statsSwiper = null;
                    }
                    applyGridLayout();
                }

                function handleResize() {
                    if (window.innerWidth >= MD_BREAKPOINT) {
                        destroySwiper();
                    } else {
                        createSwiper();
                    }
                }

                handleResize();
                window.addEventListener('resize', _debounce(handleResize, 150));
            }
        }
        // END STATS PANEL SLIDER

        // START GALLERY THUMB PANEL SLIDER
        for (const panel of galleryPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="thumb-swiper"]');
            const swiperElementThumbs = panel.querySelector('.swiper[data-swiper-type="thumb-swiper-thumbs"]');
            const swiperIndex = swiperElement.dataset.swiperIndex;
            const nextEl = `button[data-swiper-go-next="thumb-swiper-${swiperIndex}"]`;
            const prevEl = `button[data-swiper-go-prev="thumb-swiper-${swiperIndex}"]`;

            if (!!swiperElement && !!swiperElementThumbs) {
                let thumbSwiper;
                let thumbSwiperThumbs;

                thumbSwiperThumbs = new Swiper(swiperElementThumbs, {
                    loop: true,
                    spaceBetween: 6,
                    slidesPerView: 2.1,
                    freeMode: true,
                    watchSlidesProgress: true,
                    autoplay: swiperElementThumbs.dataset.autoPlay === 'true',
                    breakpoints: {
                        768: {
                            spaceBetween: 8,
                            slidesPerView: 3,
                        },
                        1024: {
                            spaceBetween: 12,
                            slidesPerView: 4,
                        }
                    }
                });
                thumbSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    loop: true,
                    spaceBetween: 16,
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    thumbs: {
                        swiper: thumbSwiperThumbs,
                    },
                    on: {
                        slideChangeTransitionStart: function () {
                            const slides = swiperElement.querySelectorAll('.swiper-slide');

                            slides.forEach((slide, index) => {
                                if (index !== this.activeIndex) {
                                    const videos = slide.querySelectorAll('video');
                                    videos.forEach(video => {
                                        if (!video.paused) {
                                            video.pause();
                                        }
                                    });

                                    const iframes = slide.querySelectorAll('iframe[data-og-source]');
                                    iframes.forEach(iframe => {
                                        const src = iframe.getAttribute('data-og-source');

                                        if (src) {
                                            const newIframe = document.createElement('iframe');

                                            for (let { name, value } of iframe.attributes) {
                                                if (name !== 'src') {
                                                    newIframe.setAttribute(name, value);
                                                }
                                            }
                                            newIframe.setAttribute('src', src);
                                            iframe.replaceWith(newIframe);
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
        }
        // END GALLERY THUMB PANEL SLIDER

        // START TESTIMONIAL PANEL SLIDER
        for (const panel of testimonialSliderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-slider-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1450: {
                            slidesPerView: 2,
                            spaceBetween: 32,
                        },
                    },
                });

                // Function to toggle navigation button visibility
                testimonialSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(testimonialSwiper, prevEl, nextEl);
                });

                updateNavButtons(testimonialSwiper, prevEl, nextEl);
            }
        }
        // END TESTIMONIAL PANEL SLIDER

        // START TESTIMONIAL PANEL FADER
        for (const panel of testimonialFaderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-fader"]');

            if (swiperElement) {
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-fader-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-fader-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    loop: true,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-fader-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        },
                        1024: {
                            slidesPerView: 1,
                        },
                        1450: {
                            slidesPerView: 1,
                        },
                    },
                });

                // Function to toggle navigation button visibility
                testimonialSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(testimonialSwiper, prevEl, nextEl);
                });

                updateNavButtons(testimonialSwiper, prevEl, nextEl);
            }
        }
        // END TESTIMONIAL PANEL FADER

        // START HOME HERO PANEL SLIDER
        for (const panel of homeHeroPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="home-hero-slider"]');

            if (swiperElement) {
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const prevEl = `[data-swiper-go-prev="home-hero-slider-${swiperIndex}"]`;
                const nextEl = `[data-swiper-go-next="home-hero-slider-${swiperIndex}"]`;

                const homeHeroSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 48,
                    centeredSlides: false,
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 64,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 80,
                        },
                    },
                });

                homeHeroSwiper.on('reachBeginning reachEnd slideChange resize', function () {
                    updateNavButtons(homeHeroSwiper, prevEl, nextEl);
                });

                // Update nav buttons on window resize (debounced)
                window.addEventListener('resize', _debounce(() => {
                    updateNavButtons(homeHeroSwiper, prevEl, nextEl);
                }, 150));

                updateNavButtons(homeHeroSwiper, prevEl, nextEl);
            }
        }
        // END HOME HERO PANEL SLIDER

        // START TESTIMONIAL MODULE SLIDER
        const testimonialModuleSliders = document.querySelectorAll('.testimonial-slider-module');
        for (const module of testimonialModuleSliders) {
            const swiperElement = module.querySelector('.swiper[data-swiper-type="testimonial-module-slider"]');

            if (swiperElement) {
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const nextEl = `button[data-swiper-go-next="testimonial-module-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-module-slider-${swiperIndex}"]`;

                // Get all author spans in this module
                const authorSpans = module.querySelectorAll('.testimonial-author');

                // Function to update visible author
                const updateAuthor = (activeIndex) => {
                    authorSpans.forEach((span, index) => {
                        if (index === activeIndex) {
                            span.classList.remove('hidden');
                        } else {
                            span.classList.add('hidden');
                        }
                    });
                };

                const testimonialModuleSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    loop: false,
                    speed: 500,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 8000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                });

                // Update author on slide change
                testimonialModuleSwiper.on('slideChange', function () {
                    updateAuthor(this.realIndex);
                });
            }
        }
        // END TESTIMONIAL MODULE SLIDER

    }
});
